import React from 'react';
import { SageTokens, IconCard, Icon, SageClassnames, Frame } from '@kajabi/sage-react';
import { ERROR_TYPES } from 'common/components/CopyMagic/constants';
import { useUiResourceContext } from 'common/components/CopyMagic/contexts';

const ErrorMessageInline = () => {
  const { error } = useUiResourceContext();

  if (!error) return null;

  const iconColor =
    error?.type === ERROR_TYPES.WARN ? IconCard.COLORS.WARNING : IconCard.COLORS.DANGER;

  return (
    <div
      data-testid="copy-magic-error-message-inline"
      className={[
        SageClassnames.TYPE.BODY_SMALL_MED,
        'copy-magic-error-inline',
        `copy-magic-error-inline--${error.type}`,
      ].join(' ')}
    >
      <Frame
        align={Frame.ALIGNMENTS.TOP_LEFT}
        borderRadius={Frame.BORDER_RADII.MD}
        direction={Frame.DIRECTIONS.HORIZONTAL}
        gap={Frame.GAPS.SM}
        width={Frame.WIDTHS.FILL}
      >
        <IconCard
          color={iconColor}
          icon={SageTokens.ICONS.WARNING_FILLED}
          size={Icon.SIZES.MD}
          style={{ marginTop: '2px', padding: 0, alignItems: 'flex-start' }}
        />
        {error.message}
      </Frame>
    </div>
  );
};

export default ErrorMessageInline;
